/**
 * Extra small screen / phone
 */
export const BREAKPOINT_XS = 0;

/**
 * Small screen / phone
 */
export const BREAKPOINT_SM = 576;

/**
 * Medium screen / tablet
 */
export const BREAKPOINT_MD = 768;

/**
 * Large screen / desktop
 */
export const BREAKPOINT_LG = 992;

/**
 * Extra large screen / wide desktop
 */
export const BREAKPOINT_XL = 1200;

/**
 * Mega large screen / wide desktop
 */
export const BREAKPOINT_XXL = 1400;
